import './about.css';
import Award from '../../img/award.jpeg';

const About = () => {
	return (
		<div className='a'>
			<div className='a-left'>
				<div className='a-card bg'></div>
				<div className='a-card'>
					<img
						src='https://images.pexels.com/photos/3585047/pexels-photo-3585047.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500'
						alt=''
						className='a-img'
					/>
				</div>
			</div>
			<div className='a-right'>
				<h1 className='a-title'>About Me</h1>
				<p className='a-desc'>
					A NIT Raipur student having specialization in Civil Engineering and
					minor in Data Science , Training and Placement coordinator.
				</p>
				<p className='a-desc'>
					In general, you will find me next to my laptop, having skills on
					ReactJs, NodeJs, MongoDb, Tableau, Python and R.
				</p>

				<div className='a-award'>
					<img src={Award} alt='' className='a-award-img' />
					<div className='a-award-texts'>
						<h4 className='a-award-title'>React Developer</h4>
						<p className='a-award-desc'>
							Online photo gallery, Github clone and much more interesting
							projects✨
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default About;
